export default __webpack_public_path__ + "static/media/GudrunLovelace.16919c47.png";